import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import DrawerModal from './DrawerModal';
import styled, { css } from 'styled-components/macro';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import useIni from '../..//hooks/useIni';
import { nombreEleccion } from 'constantes';


/**
 * Drawer accesible que permite navegar entre las elecciones,
 * la página de inicio y la página de estadísticas.
 *
 */


const Drawer = withRouter(({ className, page, icon }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ini = useIni();
  const nomenclator = useNomenclator();
  const elections = computeElections(
    ini?.botones,
    nomenclator.nomAmbitos,
    nomenclator.ordAmbitos
  );
  return (
    <DrawerModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      icon={icon}
      className={className}
    >
      <nav>
        <ul>
          {elections.map(elec => (
            <StyledListItem selected={elec.page === page} key={elec.path}>
              <StyledLink
                selected={elec.page === page}
                onClick={() => setIsOpen(false)}
                to={elec.path}
              >
                {elec.name}
              </StyledLink>
            </StyledListItem>
          ))}
        </ul>
      </nav>
    </DrawerModal>
  );
});

const computeElections = (iniButtons, ambitos, ordenAmbitos) => {
  const inicio = { path: '/inicio', name: 'Inicio', page: 'inicio' };
  const estadisticas = {
    path: '/estadisticas/alcalde',
    name: 'Estadísticas',
    page: 'estadisticas',
  };
  const activeButtons = iniButtons
    .filter(b => b.hab === 'activado')
    .map(b => b.id);
  const activeAmbitos = Object.entries(ambitos).filter(([idx, amb]) =>
    activeButtons.includes(String(idx))
  );
  const elections = activeAmbitos.map(([idx, amb]) => ({
    id: idx,
    path: '/' + nombreEleccion[idx] + '/0/colombia',
    name: amb.n,
    page: nombreEleccion[idx],
  }));
  elections.sort(
    (a, b) => ordenAmbitos.indexOf(a.id) - ordenAmbitos.indexOf(b.id)
  );
  elections.unshift(inicio);
  elections.push(estadisticas);
  return elections;
};

export default Drawer;

const StyledListItem = styled.li`
  position: relative;
  display: flex;
  flex-direction: row;
  height: 44px;
  margin-left: 12px;
  margin-right: 12px;
  margin-top: 2px;
  margin-bottom: 2px;
  border-radius: 12px;
  ${({ selected }) =>
    selected &&
    css`
      background-color: #F5F8FD;
    `}
  &:hover {
    background-color: #F5F8FD;
  }
`;

const StyledLink = styled(Link)`
  box-sizing: border-box;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: block;
  padding-left: 20px;
  line-height: 44px;
  color: #164192;
  &:hover {
    text-decoration: none;
    color: #164192;
  }
`;
